import { getParams } from '../../utils';

//获取AI应用详情
export const getAiResult = post => {
  const options = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(
    `/ai-web/dicom/airesult4box?study_uid=${post.study_uid}&series_uid=${post.series_uid}&sop_instance_uid=${post.sop_instance_uid}&aiProductType=${post.aiProductType}`,
    options
  ).then(res => res.json(), err => console.error(err));
};
//获取AI应用详情（合并后）
export const detailList4Study = post => {
  const options = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(
    `/ai-web/fromDr/detailList4Study?studyDrId=${post.id}&aiProductType=${post.type}`,
    options
  ).then(res => res.json(), err => console.error(err));
};
//获取质控详情
export const dicomBy3Uid = (studyUid, seriesUid, sopInstanceId) => {
  const url = `/ai-web/fromDr/dicomBy3Uid?studyUid=${studyUid}&seriesUid=${seriesUid}&sopInstanceId=${sopInstanceId}`;
  const options = { method: 'GET' };
  return fetch(url, options).then(res => res.json(), err => console.error(err));
};

export const updateDcmQc = data => {
  const options = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  const search = getParams(data);
  return fetch(`/ai-web/fromDr/updateDcmQc?${search}`, options).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const dcmQc = GET => {
  const options = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(`/ai-web/fromDr/dcmQc?dicomDrId=${GET}`, options).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const aihis = data => {
  const offset = data.offset;
  const rows = data.rows;
  const type = data.aiProductType;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(
    `/ai-web/dicom/aihis?offset=${offset}&rows=${rows}&aiProductType=${type}`,
    init
  ).then(res => res.json(), err => console.error(err));
};

export const remainings = post => {
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(
    `/ai-web/dicom/remainings?aiProductType=${post.aiProductType}`,
    init
  ).then(res => res.json(), err => console.error(err));
};

//获取AI应用列表
export const dicomrecord = data => {
  const search = getParams(data);
  let url = `/ai-web/fromDr/dicomrecord?${search}`;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
//获取AI应用列表（合并后的）
export const studyRecord = data => {
  const search = getParams(data);
  let url = `/ai-web/fromDr/studyrecord?${search}`;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

export const institutionRecord = (data = {}) => {
  const search = getParams(data);
  let url = `/ai-web/fromDr/institutionRecord?` + search;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//AI应用医生审核
export const doctorReview = data => {
  const search = getParams(data);
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  let url = `/ai-web/fromDr/doctorReview?${search}`;

  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
//AI应用医生审核（合并后）
export const doctorReview4Study = data => {
  const search = getParams(data);
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  let url = `/ai-web/fromDr/doctorReview4Study?${search}`;

  return fetch(url, init).then(res => res.json(), err => console.error(err));
};
//AI应用获取医生审核结果
export const doctorReviewRecord = data => {
  const search = getParams(data);
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  let url = `/ai-web/fromDr/doctorReviewRecord?${search}`;
  if (data.token) url += `&token=${data.token}`;
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//AI应用获取医生审核结果（合并后）
export const doctorReviewRecord4Study = data => {
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  let url = `/ai-web/fromDr/doctorReviewRecord4Study?studyDrId=${data.id}`;
  if (data.token) url += `&token=${data.token}`;
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//AI应用获取医生审核历史
export const doctorReviewRecordHis = data => {
  const id = data.id;
  const type = data.type;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  const url = `/ai-web/fromDr/doctorReviewRecordHis?dicomDrId=${id}&aiProductType=${type}`;
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//AI应用获取医生审核历史(合并后)
export const doctorReviewRecordHis4Study = data => {
  const id = data.id;
  // const type = data.type;
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  const url = `/ai-web/fromDr/doctorReviewRecordHis4Study?studyDrId=${id}`;
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//获取质控结果详情
export const qcResult = id => {
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };
  return fetch(`/ai-web/fromDr/qcResult?dicomDrId=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//智能筛查列表
export const tubeStudyApplyList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/tubeStudy/applyList`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//智能筛查审核列表
export const tubeStudyReviewList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/tubeStudy/reviewList`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//智能筛查-详情
export const tubeStudyDetail = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/tubeStudy/detail?id=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//智能筛查-医生审核列表
export const tubeReviewDict = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/tubeReview`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//智能筛查-一审
export const tubeStudyReview = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/tubeStudy/review?id=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//智能筛查-二审
export const tubeStudyPrivatReview = (id, type) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/tubeStudy/privatReview?tubeStudyId=${id}&reviewType=${type}`,
    init
  ).then(res => res.json(), err => console.error(err));
};

//智能筛查-提交审核（一审）
export const tubeStudySave = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/tubeStudy/saveReview`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//智能筛查-提交审核（二审、三审）
export const savePrivatReview = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/tubeStudy/savePrivatReview`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//智能筛查-放弃操作（一审）
export const tubeStudyQuitReview = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/tubeStudy/quitReview?id=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//智能筛查-放弃操作（二审）
export const quitPrivateReview = (id, type) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/tubeStudy/quitPrivateReview?tubeStudyId=${id}&reviewType=${type}`,
    init
  ).then(res => res.json(), err => console.error(err));
};

//智能筛查-开始修改审核结果
export const reTubeStudyReview = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/tubeStudy/review_2?id=${id}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
